var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _g, _path218, _g2, _path219, _g3, _path220, _g4, _path221, _g5, _path222, _g6, _path223, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 136,
    height: 136
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 3.08691H57.4175V8.51996H62.8505V3.08691Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 3.08691H68.2834V8.51996H73.7165V3.08691Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 3.08691H73.7166V8.51996H79.1496V3.08691Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 3.08691H79.1494V8.51996H84.5825V3.08691Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 3.08691H84.5825V8.51996H90.0156V3.08691Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 8.51953H46.5513V13.9526H51.9843V8.51953Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 8.51953H57.4175V13.9526H62.8505V8.51953Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 8.51953H62.8506V13.9526H68.2836V8.51953Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 8.51953H68.2834V13.9526H73.7165V8.51953Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 8.51953H73.7166V13.9526H79.1496V8.51953Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 8.51953H90.0156V13.9526H95.4487V8.51953Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 13.9531H46.5513V19.3862H51.9843V13.9531Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 13.9531H57.4175V19.3862H62.8505V13.9531Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 13.9531H90.0156V19.3862H95.4487V13.9531Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 19.3857H62.8506V24.8188H68.2836V19.3857Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 19.3857H68.2834V24.8188H73.7165V19.3857Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 19.3857H79.1494V24.8188H84.5825V19.3857Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 19.3857H84.5825V24.8188H90.0156V19.3857Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4174 24.8193H51.9844V30.2524H57.4174V24.8193Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 24.8193H57.4175V30.2524H62.8505V24.8193Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 24.8193H62.8506V30.2524H68.2836V24.8193Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 24.8193H79.1494V30.2524H84.5825V24.8193Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 24.8193H90.0156V30.2524H95.4487V24.8193Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 30.252H57.4175V35.685H62.8505V30.252Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 30.252H62.8506V35.685H68.2836V30.252Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 30.252H73.7166V35.685H79.1496V30.252Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 30.252H84.5825V35.685H90.0156V30.252Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 30.252H90.0156V35.685H95.4487V30.252Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 35.6855H46.5513V41.1186H51.9843V35.6855Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 35.6855H57.4175V41.1186H62.8505V35.6855Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 35.6855H68.2834V41.1186H73.7165V35.6855Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 35.6855H79.1494V41.1186H84.5825V35.6855Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 35.6855H90.0156V41.1186H95.4487V35.6855Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 41.1182H57.4175V46.5512H62.8505V41.1182Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 41.1182H62.8506V46.5512H68.2836V41.1182Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 41.1182H68.2834V46.5512H73.7165V41.1182Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 41.1182H84.5825V46.5512H90.0156V41.1182Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 41.1182H90.0156V46.5512H95.4487V41.1182Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 46.5508H8.52002V51.9838H13.9531V46.5508Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3862 46.5508H13.9531V51.9838H19.3862V46.5508Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.819 46.5508H19.386V51.9838H24.819V46.5508Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6852 46.5508H30.2522V51.9838H35.6852V46.5508Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1183 46.5508H35.6853V51.9838H41.1183V46.5508Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 46.5508H57.4175V51.9838H62.8505V46.5508Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 46.5508H73.7166V51.9838H79.1496V46.5508Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 46.5508H84.5825V51.9838H90.0156V46.5508Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 46.5508H122.614V51.9838H128.047V46.5508Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 46.5508H128.047V51.9838H133.48V46.5508Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3862 51.9844H13.9531V57.4174H19.3862V51.9844Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2521 51.9844H24.8191V57.4174H30.2521V51.9844Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6852 51.9844H30.2522V57.4174H35.6852V51.9844Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 51.9844H46.5513V57.4174H51.9843V51.9844Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 51.9844H57.4175V57.4174H62.8505V51.9844Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 51.9844H73.7166V57.4174H79.1496V51.9844Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 51.9844H79.1494V57.4174H84.5825V51.9844Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 51.9844H84.5825V57.4174H90.0156V51.9844Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M111.748 51.9844H106.315V57.4174H111.748V51.9844Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M122.614 51.9844H117.181V57.4174H122.614V51.9844Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 51.9844H128.047V57.4174H133.48V51.9844Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51996 57.417H3.08691V62.85H8.51996V57.417Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1183 57.417H35.6853V62.85H41.1183V57.417Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5515 57.417H41.1184V62.85H46.5515V57.417Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4174 57.417H51.9844V62.85H57.4174V57.417Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 57.417H62.8506V62.85H68.2836V57.417Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 57.417H68.2834V62.85H73.7165V57.417Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 57.417H73.7166V62.85H79.1496V57.417Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 57.417H90.0156V62.85H95.4487V57.417Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M100.882 57.417H95.4487V62.85H100.882V57.417Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 57.417H122.614V62.85H128.047V57.417Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51996 62.8506H3.08691V68.2836H8.51996V62.8506Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 62.8506H8.52002V68.2836H13.9531V62.8506Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 62.8506H46.5513V68.2836H51.9843V62.8506Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4174 62.8506H51.9844V68.2836H57.4174V62.8506Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 62.8506H57.4175V68.2836H62.8505V62.8506Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 62.8506H62.8506V68.2836H68.2836V62.8506Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 62.8506H68.2834V68.2836H73.7165V62.8506Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 62.8506H90.0156V68.2836H95.4487V62.8506Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M100.882 62.8506H95.4487V68.2836H100.882V62.8506Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M111.748 62.8506H106.315V68.2836H111.748V62.8506Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M122.614 62.8506H117.181V68.2836H122.614V62.8506Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 62.8506H122.614V68.2836H128.047V62.8506Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 62.8506H128.047V68.2836H133.48V62.8506Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3862 68.2832H13.9531V73.7162H19.3862V68.2832Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M24.819 68.2832H19.386V73.7162H24.819V68.2832Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6852 68.2832H30.2522V73.7162H35.6852V68.2832Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1183 68.2832H35.6853V73.7162H41.1183V68.2832Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5515 68.2832H41.1184V73.7162H46.5515V68.2832Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 68.2832H46.5513V73.7162H51.9843V68.2832Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 68.2832H68.2834V73.7162H73.7165V68.2832Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 68.2832H79.1494V73.7162H84.5825V68.2832Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 68.2832H84.5825V73.7162H90.0156V68.2832Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M100.882 68.2832H95.4487V73.7162H100.882V68.2832Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M106.315 68.2832H100.882V73.7162H106.315V68.2832Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M117.181 68.2832H111.748V73.7162H117.181V68.2832Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M122.614 68.2832H117.181V73.7162H122.614V68.2832Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 68.2832H122.614V73.7162H128.047V68.2832Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M138.913 68.2832H133.48V73.7162H138.913V68.2832Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 73.7168H8.52002V79.1498H13.9531V73.7168Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M24.819 73.7168H19.386V79.1498H24.819V73.7168Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6852 73.7168H30.2522V79.1498H35.6852V73.7168Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 73.7168H46.5513V79.1498H51.9843V73.7168Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 73.7168H62.8506V79.1498H68.2836V73.7168Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 73.7168H68.2834V79.1498H73.7165V73.7168Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 73.7168H79.1494V79.1498H84.5825V73.7168Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 73.7168H90.0156V79.1498H95.4487V73.7168Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M106.315 73.7168H100.882V79.1498H106.315V73.7168Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M111.748 73.7168H106.315V79.1498H111.748V73.7168Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M117.181 73.7168H111.748V79.1498H117.181V73.7168Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 73.7168H128.047V79.1498H133.48V73.7168Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M138.913 73.7168H133.48V79.1498H138.913V73.7168Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 79.1494H8.52002V84.5825H13.9531V79.1494Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2521 79.1494H24.8191V84.5825H30.2521V79.1494Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1183 79.1494H35.6853V84.5825H41.1183V79.1494Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 79.1494H46.5513V84.5825H51.9843V79.1494Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 79.1494H57.4175V84.5825H62.8505V79.1494Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 79.1494H62.8506V84.5825H68.2836V79.1494Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 79.1494H79.1494V84.5825H84.5825V79.1494Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 79.1494H84.5825V84.5825H90.0156V79.1494Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 79.1494H90.0156V84.5825H95.4487V79.1494Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M122.614 79.1494H117.181V84.5825H122.614V79.1494Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 79.1494H122.614V84.5825H128.047V79.1494Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 79.1494H128.047V84.5825H133.48V79.1494Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51996 84.583H3.08691V90.0161H8.51996V84.583Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3862 84.583H13.9531V90.0161H19.3862V84.583Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M24.819 84.583H19.386V90.0161H24.819V84.583Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2521 84.583H24.8191V90.0161H30.2521V84.583Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5515 84.583H41.1184V90.0161H46.5515V84.583Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 84.583H46.5513V90.0161H51.9843V84.583Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 84.583H57.4175V90.0161H62.8505V84.583Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 84.583H62.8506V90.0161H68.2836V84.583Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 84.583H68.2834V90.0161H73.7165V84.583Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 84.583H73.7166V90.0161H79.1496V84.583Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 84.583H79.1494V90.0161H84.5825V84.583Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 84.583H90.0156V90.0161H95.4487V84.583Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 84.583H128.047V90.0161H133.48V84.583Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M138.913 84.583H133.48V90.0161H138.913V84.583Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2521 90.0156H24.8191V95.4487H30.2521V90.0156Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6852 90.0156H30.2522V95.4487H35.6852V90.0156Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1183 90.0156H35.6853V95.4487H41.1183V90.0156Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 90.0156H46.5513V95.4487H51.9843V90.0156Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4174 90.0156H51.9844V95.4487H57.4174V90.0156Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 90.0156H57.4175V95.4487H62.8505V90.0156Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 90.0156H62.8506V95.4487H68.2836V90.0156Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 90.0156H73.7166V95.4487H79.1496V90.0156Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 90.0156H79.1494V95.4487H84.5825V90.0156Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 90.0156H84.5825V95.4487H90.0156V90.0156Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 90.0156H90.0156V95.4487H95.4487V90.0156Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M100.882 90.0156H95.4487V95.4487H100.882V90.0156Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M106.315 90.0156H100.882V95.4487H106.315V90.0156Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M111.748 90.0156H106.315V95.4487H111.748V90.0156Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M117.181 90.0156H111.748V95.4487H117.181V90.0156Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 90.0156H122.614V95.4487H128.047V90.0156Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 90.0156H128.047V95.4487H133.48V90.0156Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M138.913 90.0156H133.48V95.4487H138.913V90.0156Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 95.4492H46.5513V100.882H51.9843V95.4492Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 95.4492H62.8506V100.882H68.2836V95.4492Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 95.4492H73.7166V100.882H79.1496V95.4492Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 95.4492H90.0156V100.882H95.4487V95.4492Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M117.181 95.4492H111.748V100.882H117.181V95.4492Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 95.4492H122.614V100.882H128.047V95.4492Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 95.4492H128.047V100.882H133.48V95.4492Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 100.882H57.4175V106.315H62.8505V100.882Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 100.882H62.8506V106.315H68.2836V100.882Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 100.882H73.7166V106.315H79.1496V100.882Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 100.882H84.5825V106.315H90.0156V100.882Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 100.882H90.0156V106.315H95.4487V100.882Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M106.315 100.882H100.882V106.315H106.315V100.882Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M117.181 100.882H111.748V106.315H117.181V100.882Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M122.614 100.882H117.181V106.315H122.614V100.882Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 100.882H122.614V106.315H128.047V100.882Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 100.882H128.047V106.315H133.48V100.882Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M138.913 100.882H133.48V106.315H138.913V100.882Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 106.314H46.5513V111.747H51.9843V106.314Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 106.314H79.1494V111.747H84.5825V106.314Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 106.314H90.0156V111.747H95.4487V106.314Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M117.181 106.314H111.748V111.747H117.181V106.314Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4174 111.748H51.9844V117.181H57.4174V111.748Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 111.748H57.4175V117.181H62.8505V111.748Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 111.748H62.8506V117.181H68.2836V111.748Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 111.748H90.0156V117.181H95.4487V111.748Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M100.882 111.748H95.4487V117.181H100.882V111.748Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M106.315 111.748H100.882V117.181H106.315V111.748Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M111.748 111.748H106.315V117.181H111.748V111.748Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M117.181 111.748H111.748V117.181H117.181V111.748Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 111.748H128.047V117.181H133.48V111.748Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M138.913 111.748H133.48V117.181H138.913V111.748Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 117.181H46.5513V122.614H51.9843V117.181Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 117.181H62.8506V122.614H68.2836V117.181Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 117.181H68.2834V122.614H73.7165V117.181Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1496 117.181H73.7166V122.614H79.1496V117.181Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M100.882 117.181H95.4487V122.614H100.882V117.181Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M106.315 117.181H100.882V122.614H106.315V117.181Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M117.181 117.181H111.748V122.614H117.181V117.181Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M122.614 117.181H117.181V122.614H122.614V117.181Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M138.913 117.181H133.48V122.614H138.913V117.181Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 122.614H46.5513V128.047H51.9843V122.614Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 122.614H57.4175V128.047H62.8505V122.614Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7165 122.614H68.2834V128.047H73.7165V122.614Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 122.614H79.1494V128.047H84.5825V122.614Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4487 122.614H90.0156V128.047H95.4487V122.614Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M100.882 122.614H95.4487V128.047H100.882V122.614Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M106.315 122.614H100.882V128.047H106.315V122.614Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M111.748 122.614H106.315V128.047H111.748V122.614Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M117.181 122.614H111.748V128.047H117.181V122.614Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 122.614H128.047V128.047H133.48V122.614Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9843 128.047H46.5513V133.48H51.9843V128.047Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2836 128.047H62.8506V133.48H68.2836V128.047Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5825 128.047H79.1494V133.48H84.5825V128.047Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0156 128.047H84.5825V133.48H90.0156V128.047Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M100.882 128.047H95.4487V133.48H100.882V128.047Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M106.315 128.047H100.882V133.48H106.315V128.047Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M117.181 128.047H111.748V133.48H117.181V128.047Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M122.614 128.047H117.181V133.48H122.614V128.047Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 128.047H122.614V133.48H128.047V128.047Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4174 133.48H51.9844V138.914H57.4174V133.48Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8505 133.48H57.4175V138.914H62.8505V133.48Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 133.48H122.614V138.914H128.047V133.48Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M133.48 133.48H128.047V138.914H133.48V133.48Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M138.913 133.48H133.48V138.914H138.913V133.48Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142 0H0V142H142V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_220_279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 39,
    height: 39
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08691 3.08691V41.1182H41.1182V3.08691H3.08691ZM8.51996 8.51996H35.6852V35.6852H8.51996V8.51996Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_220_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1182 3.08691H3.08691V41.1182H41.1182V3.08691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_220_279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 18,
    height: 18
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2523 13.9531H13.9531V30.2523H30.2523V13.9531Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_220_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2523 13.9531H13.9531V30.2523H30.2523V13.9531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_220_279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 3,
    width: 39,
    height: 39
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.913 3.08691L100.882 3.08691V41.1182H138.913V3.08691ZM133.48 8.51996V35.6852H106.315V8.51996L133.48 8.51996Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_220_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.913 3.08691H100.882V41.1182H138.913V3.08691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_220_279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 13,
    width: 18,
    height: 18
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 30.2523V13.9531L111.748 13.9531V30.2523H128.047Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_220_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.047 13.9531H111.748V30.2523H128.047V13.9531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_220_279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 100,
    width: 39,
    height: 39
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08691 138.913H41.1182V100.882H3.08691L3.08691 138.913ZM8.51996 133.48L8.51996 106.315H35.6852V133.48H8.51996Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_220_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1182 100.882H3.08691V138.913H41.1182V100.882Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_220_279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 111,
    width: 18,
    height: 18
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 111.748L13.9531 128.047H30.2523V111.748H13.9531Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_220_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2523 111.748H13.9531V128.047H30.2523V111.748Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.2e872bcd5c3e6e271611f7da9fb2a0cb.svg";
export { ForwardRef as ReactComponent };